import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {message} from "antd";
import ContentMenuSty from  './contentMenu.module.css'
import {getBusiness, getBusinessCate} from "../BussinessScope/service";

const ContentMenu = (props) => {
    const { history } = props;
    const [businessCateData, setBusinessCate] = useState([]);

    useEffect(() => {
        (async () => {
            const businessCate = await getBusinessCate({page: 1, size: 100});
            const business = await getBusiness({page: 1, size: 100});

            businessCate.data.list.map((businessCateItem, index) => {
                businessCateItem.children = business.data.list.filter(businessItem => {
                    if (businessItem.cate_id === businessCateItem.id) {
                        return businessItem
                    }
                });
            });

            setBusinessCate(businessCate.data.list);
        })();
    }, []);

    return (
        <div className={ContentMenuSty.contentMenuDiv}>
            <div className={ContentMenuSty.inlineDiv} style={{display: 'flex', justifyContent: 'space-between'}}>
                {
                    businessCateData.map((item, index) => {
                        if(item.title!=='咨询服务'){
                            return (
                                <div key={index} onClick={() => {
                                    window.scrollTo(0,300);
                                    item.children.length > 0 ? history.push({pathname: `/bussiness/${item.children[0].id}`}) : message.warn('暂无数据');
                                }}>
                                    <span className={ContentMenuSty.MenuTitleCH} >{item.title}</span>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </div>

    );
};

export default connect()(withRouter(ContentMenu));
